import '../../styles/eventDatePicker.scss';
import { Box, TextField, MenuItem } from '@mui/material';
import { useState } from 'react';
import { Button } from '../button';
import { useNavigate } from 'react-router-dom';

const months = [
  'January', 'February', 'March', 'April', 'May', 'June', 
  'July', 'August', 'September', 'October', 'November', 'December'
];

const days = Array.from({ length: 31 }, (_, i) => i + 1);
const years = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i);

export const EventDatePicker = () => {
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/the-look');
  };

  return (
    <div className='event-date-picker'>
      <div className='event-date-picker-container'>
        <Box display='flex' flexDirection='column' alignItems='center' gap={2}>
          <h2>What is your event date?</h2>
          <Box display='flex' flexDirection='row' gap={2}>
            <TextField
            sx={{ width: '200px' }}
              select
              label='Month'
              value={selectedMonth}
              onChange={(e: any) => setSelectedMonth(e.target.value)}
              variant='outlined'
            >
              {months.map((month, index) => (
                <MenuItem key={index} value={month}>{month}</MenuItem>
              ))}
            </TextField>

            <TextField
            sx={{ width: '200px' }}
              select
              label='Day'
              value={selectedDay}
              onChange={(e: any) => setSelectedDay(e.target.value)}
              variant='outlined'
            >
              {days.map((day) => (
                <MenuItem key={day} value={day}>{day}</MenuItem>
              ))}
            </TextField>

            <TextField
            sx={{ width: '200px' }}
              select
              label='Year'
              value={selectedYear}
              onChange={(e: any) => setSelectedYear(e.target.value)}
              variant='outlined'
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </TextField>
          </Box>
          <Button 
            onClick={handleNext} 
            text='Next'
          ></Button>
        </Box>
      </div>
    </div>
  );
};

